module.exports = __webpack_public_path__ + "media/images/icons/flags/SY-5337ecd03a4c50b4ec1c31d48569dab3.svg";